import { useState } from "react";
import { api, apiError } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Loader2, KeyRound } from "lucide-react";

const genPassword = () => `Temp${Math.random().toString(36).slice(2, 8)}${Math.floor(100 + Math.random() * 900)}`;

export default function ResetPasswordDialog({ user, onOpenChange, onDone }) {
  const [pwd, setPwd] = useState(genPassword);
  const [saving, setSaving] = useState(false);

  const submit = async () => {
    if (pwd.length < 10) return toast.error("Minimum 10 characters with letters and numbers");
    setSaving(true);
    try {
      await api.post(`/users/${user.id}/reset-password`, { temp_password: pwd });
      toast.success(`Password reset. Temporary password: ${pwd}`, { duration: 15000 });
      onOpenChange(false);
      onDone();
    } catch (e) { toast.error(apiError(e, "Could not reset password")); }
    finally { setSaving(false); }
  };

  if (!user) return null;
  return (
    <Dialog open={!!user} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="reset-password-dialog">
        <DialogHeader>
          <DialogTitle className="font-head flex items-center gap-2"><KeyRound className="h-5 w-5 text-teal-600" /> Reset Password</DialogTitle>
          <DialogDescription>{user.name} ({user.email}) will be signed out everywhere and must set a new password on next login.</DialogDescription>
        </DialogHeader>
        <div className="space-y-2 py-2">
          <Label>Temporary Password</Label>
          <div className="flex gap-2">
            <Input data-testid="reset-temp-password-input" value={pwd} onChange={(e) => setPwd(e.target.value)} className="font-mono" />
            <Button type="button" variant="outline" onClick={() => setPwd(genPassword())}>Generate</Button>
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
          <Button data-testid="reset-password-submit" onClick={submit} disabled={saving} className="bg-teal-600 hover:bg-teal-700 text-white">
            {saving ? <Loader2 className="h-4 w-4 animate-spin" /> : "Reset Password"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
